import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";
import {useEffect, useState} from "react";
import {livraisonACreer} from "services/apiLivraisons";

const AlertLivraisonMissing = ({forAdmin}: { forAdmin: boolean }) => {
	const [missingLivraisons, setMissingLivraisons] = useState<boolean>(true);
	const [missingLivraisonsGroupes, setMissingLivraisonsGroupes] = useState<string[]>([]);

	useEffect(() => {
		const fetchLivraisons = async () => {
			const result = await livraisonACreer();
			setMissingLivraisons(result && result.length > 0);
			setMissingLivraisonsGroupes(result);
		}
		fetchLivraisons();
	}, []);

	return (
		missingLivraisons ? (
			<div className="bg-alert-100 border border-alert-600 text-alert-600 p-4 mb-4 rounded-md">
				<div className="flex items-center gap-2">
					<ExclamationTriangleIcon className="w-6 h-6"/>
					{forAdmin ? (
						<p>Un ou plusieurs livraisons sont manquantes pour les groupes suivants :</p>
					) : (
						<p>Votre groupe manque d'une livraison, veuillez contacter l'apiculteur</p>
					)}
				</div>
				{forAdmin && (
					<ul className="list-disc list-inside">
						{missingLivraisonsGroupes.map((groupe) => (
							<li key={groupe}>{groupe}</li>
						))}
					</ul>
				)}
			</div>
		) : null
	)
}

export default AlertLivraisonMissing;